import { render } from "./AuditLog.vue?vue&type=template&id=0f9cd60c"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"

import "./AuditLog.vue?vue&type=style&index=0&id=0f9cd60c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__